import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { getConsent, setConsent, initGtag } from "../lib/tracking";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const c = getConsent();
    if (c === null) setVisible(true);
    else if (c.marketing) initGtag();
  }, []);

  const decide = (granted) => {
    setConsent(granted);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-0 left-0 right-0 z-[60] border-t border-white/10 bg-[#14161B] p-4 md:bottom-4 md:left-4 md:right-auto md:max-w-md md:rounded-lg md:border"
        >
          <div className="flex items-start gap-3">
            <Cookie className="mt-0.5 shrink-0 text-[#3DDC97]" size={20} />
            <div>
              <p className="text-sm text-gray-200">
                Wir nutzen Cookies für Marketing & Reichweitenmessung (Google Ads).
                Conversions werden nur mit Ihrer Einwilligung erfasst.
              </p>
              <div className="mt-3 flex gap-2">
                <button
                  data-testid="cookie-accept-btn"
                  onClick={() => decide(true)}
                  className="rounded-md bg-[#3DDC97] px-4 py-2 text-sm font-semibold text-[#0E0F12] hover:bg-[#2BBF7E]"
                >
                  Akzeptieren
                </button>
                <button
                  data-testid="cookie-decline-btn"
                  onClick={() => decide(false)}
                  className="rounded-md border border-white/15 px-4 py-2 text-sm text-gray-300 hover:bg-white/5"
                >
                  Nur notwendige
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
